<nav class="app-rail" [class.app-rail-collapsed]="!expanded()">
  <div class="rail-group rail-group-top">
    <ng-container *ngFor="let item of topItems">
      <ng-container
        *ngIf="!item.feature; else withFeature"
        [ngTemplateOutlet]="itemTemplate"
        [ngTemplateOutletContext]="{ item: item }"
      ></ng-container>
      <ng-template #withFeature>
        <ng-container *shHasFeature="item.feature">
          <ng-container
            [ngTemplateOutlet]="itemTemplate"
            [ngTemplateOutletContext]="{ item: item }"
          ></ng-container>
        </ng-container>
      </ng-template>
    </ng-container>
  </div>

  <div class="rail-group rail-group-bottom">
    <ng-container *ngFor="let item of bottomItems">
      <ng-container
        *ngIf="!item.feature; else withFeatureBottom"
        [ngTemplateOutlet]="itemTemplate"
        [ngTemplateOutletContext]="{ item: item }"
      ></ng-container>
      <ng-template #withFeatureBottom>
        <ng-container *shHasFeature="item.feature">
          <ng-container
            [ngTemplateOutlet]="itemTemplate"
            [ngTemplateOutletContext]="{ item: item }"
          ></ng-container>
        </ng-container>
      </ng-template>
    </ng-container>

    <button
      type="button"
      class="rail-toggle"
      (click)="toggleExpanded()"
      [attr.aria-label]="
        (expanded() ? 'shell.rail.collapse' : 'shell.rail.expand') | translate
      "
    >
      <i
        class="fa-solid"
        [class.fa-angles-left]="expanded()"
        [class.fa-angles-right]="!expanded()"
      ></i>
    </button>
  </div>

  <!-- One item, rendered either as a link (no children), a flyout trigger
       (children, collapsed rail) or an inline expandable group (children,
       expanded rail). -->
  <ng-template #itemTemplate let-item="item">
    <ng-container *ngIf="!item.items?.length; else withChildren">
      <a
        class="rail-item"
        [routerLink]="item.route ? '/' + item.route : null"
        [class.rail-item-active]="isRouteActive(item.route)"
        [shTooltip]="item.label"
        tooltipPosition="right"
        [tooltipDisabled]="expanded()"
      >
        <span class="rail-item-icon">
          <img *ngIf="item.iconUrl" [src]="item.iconUrl" alt="" />
          <i
            *ngIf="!item.iconUrl && item.icon"
            [class]="fontAwesomeClass(item)"
          ></i>
        </span>
        <span class="rail-item-label" *ngIf="expanded()">{{
          item.label | translate
        }}</span>
      </a>
    </ng-container>

    <ng-template #withChildren>
      <ng-container *ngIf="expanded(); else collapsedGroup">
        <button
          type="button"
          class="rail-item rail-item-group"
          [class.rail-item-active]="isGroupActive(item)"
          (click)="toggleGroup(item)"
        >
          <span class="rail-item-icon">
            <img *ngIf="item.iconUrl" [src]="item.iconUrl" alt="" />
            <i
              *ngIf="!item.iconUrl && item.icon"
              [class]="fontAwesomeClass(item)"
            ></i>
          </span>
          <span class="rail-item-label">{{ item.label | translate }}</span>
          <i
            class="fa-solid fa-chevron-down rail-group-chevron"
            [class.rail-group-chevron-open]="isGroupOpen(item)"
          ></i>
        </button>
        <div class="rail-subgroup" *ngIf="isGroupOpen(item)">
          <a
            *ngFor="let child of item.items"
            class="rail-item rail-subitem"
            [routerLink]="child.route ? '/' + child.route : null"
            [class.rail-item-active]="isRouteActive(child.route)"
          >
            {{ child.label | translate }}
          </a>
        </div>
      </ng-container>

      <ng-template #collapsedGroup>
        <button
          type="button"
          class="rail-item"
          [class.rail-item-active]="isGroupActive(item)"
          [shTooltip]="item.label"
          tooltipPosition="right"
          (click)="flyout.toggle($event)"
        >
          <span class="rail-item-icon">
            <img *ngIf="item.iconUrl" [src]="item.iconUrl" alt="" />
            <i
              *ngIf="!item.iconUrl && item.icon"
              [class]="fontAwesomeClass(item)"
            ></i>
          </span>
        </button>
        <sh-menu #flyout [items]="flyoutItems(item)"></sh-menu>
      </ng-template>
    </ng-template>
  </ng-template>
</nav>
